module.exports = __webpack_public_path__ + "img/poster_smartScripting_R2_1.3607a92f.jpg";